import React from "react";
import { Route, Routes } from "react-router-dom";
import LandingPage from "../pages/landingPage";
import PrivateRoute from "../protectedRoute/PrivateRoute";
import PublicRoute from "../protectedRoute/publicRoute";
import LiveTest from "../pages/liveTest";
import Login from "../pages/login";
import Feedback from "../pages/feedback";
import SampleTest from "../pages/sampleTest";

export default function ExamRoutes() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/live-test" element={<PrivateRoute><LiveTest /></PrivateRoute>} />
        <Route path="/feedback" element={<PrivateRoute><Feedback /></PrivateRoute>} />
        <Route path="/sample-test" element={<PrivateRoute><SampleTest /></PrivateRoute>} />
      </Routes>
    </>
  );
}
